import apiUrl from '../../../../constants'
import user_tracker from '../../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { BasicSelect,ModelSelect} from 'vue-search-select'
import Paginate from 'vuejs-paginate'

export default {
  name: 'creategroup',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect,
    Paginate
  },
  data: function() {
		return {
			cityList: [],
			cityid: '',
      filtercityid:'',
      filterstateid:'',
      filterhubzoneid:'',
			groupType: '',
			routeMode: '',
			groupName: '',
			groupNumber: '',
			useremail: '',
			cityObjData: {
				value: "",
				text: ""
			},
			FilterCityObjData: {
				value: "",
				text: ""
			},
			FilterstateObjData: {
				value: "",
				text: ""
			},
			FilterhubzoneObjData: {
				value: "",
				text: ""
			},
			groupTypeObjData: {
				value: "",
				text: ""
			},
			groupTypeList: [{
					value: '1',
					text: "City"
				},
				{
					value: '2',
					text: "Rest Of City"
				},
				{
					value: '3',
					text: "RTO"
				}, {
					value: '4',
					text: "Rest of RTO"
				},
			],
			modeList: [{
					text: "Surface"
				},
				{
					text: "Air"
				}
			],
      listHubZoneData: [],
      HubArr: [],
      destData: [],
      modelArr:[],
      allHubData:[],
      checked:[],
      DestinationList: [],
      addmodalShow: false,
      checkAllHub:false,
      TotalAllocatedCount: 0,
      connDestLoading:false,
      disabled: false,
      clickedMB:false,
      disabledflag:false,
      routemodeArr:[],
      liststateData:[],
      savroutemode:[],
      hublist:[],
      destinationHubFound:false,
      showdestination: false,
      cityLoading:'',
      GroupNumberError:'',
      citySearchStatus: false,
      resultCount: 0,
      templateList: [],
      pageCount: 0,
			pageNo: 0,
			limit: 10,
      totalRows: 0,
      citySearchObjData: {
				value: "",
				text: ""
			},
      citySearch: '',
			citySearchName: '',
      groupStatusModal: false,
      changestatus: '',
      changestatusHub: '',
      gpstatus: '',
			gptemplateid: '',
			gpCityId: '',
      userData:[]
		}
	},

	created: function() {},
	computed: {},
  filters: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.userData = userdetail;
    this.useremail        = userdetail[0].email;

		this.getCityList();
    this.getHubZoneData();
    this.getStateListData();
  },

  methods: {
    /* select city for search */
      selectedCity(cityData) {
        this.cityObjData = cityData;
        this.cityid = cityData.value;
        this.setGroupName();
        this.groupNumber= '';
        this.destinationHubFound =false;
        this.resetDes();
      },

    /* select Group type for search */
      selectedGroupType(groupData) {
        this.groupTypeObjData = groupData;
        this.groupType = groupData.value;
        this.setGroupName();
        this.groupNumber= '';
        this.destinationHubFound = false;
        this.resetDes();
      },

    /* select group name function while search */
      setGroupName() {
        /*
        BHOPAL CITY
        REST OF GWALIOR
        UDHNA GJ RTO
        REST OF SURAT RTO
        */
        if (this.cityid != "" && this.groupType != "") {
          if (this.groupType == 1 || this.groupType == 3) this.groupName = this.cityObjData.text + ' ' + this.groupTypeObjData.text;
          else {
            this.groupName = 'Rest of ' + this.cityObjData.text;
            if (this.groupType == 4) this.groupName += ' RTO';
          }
        }
      },

    /* select city API function while search */
      getCityList() {
        var i = 0;
        this.input = ({})
        this.cityLoading = 'Loading City...';
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'allcity/get',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            var cityList = result.data.ResponseData
            for (i = 0; i < cityList.length; i++) {
              this.cityList.push({
                value: cityList[i].cityid,
                text: cityList[i].cityname
              })
            }
            this.cityLoading = '';
          }, error => {
            console.error(error)
            this.cityLoading = '';
          })
      },

    /* select city function in filter while search */
      selectFilter(){
        if(this.destinationHubFound == true){
          this.disabledflag=true;
          this.showdestination=true;
          this.getSearchDestinations();
        }else{
          this.destinationHubFound = false;
          this.getPanIndiaDestinations();
        }
      },

    /* select state API function in filter while search */
      getStateListData() {
        this.input = ({})
          axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'getStateListDetails',
            'data': this.input,
            headers: {
            'Authorization': "authkey xB84JJ89Hd25"
            }
          })
          .then((result) => {
            if(result.data.ResultCode == 100){
            var liststateData = result.data.ResponseData;
              for (let i = 0; i < liststateData.length; i++) {
                this.liststateData.push({
                  value: liststateData[i].stateid,
                  text: liststateData[i].statename
                })
              }
            }
          })
        .catch((Exception) => {
          console.error('exception is:::::::::',Exception)
          })
        },

    /* select Zone API function in filter while search */
      getHubZoneData() {
        this.input = ({})
          axios({
              method: 'POST',
              'url': apiUrl.api_url_hubops + 'hubzone/list',
              'data': this.input,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
              }
            })
          .then(result => {
            if (result.data.ResultCode == 100) {
              let listHubZoneData = result.data.ResponseData;
              for (let i = 0; i < listHubZoneData.length; i++) {
                this.listHubZoneData.push({
                  value: listHubZoneData[i].hubzoneid,
                  text: listHubZoneData[i].hubzonename
                })
              }
            }
          }, error => {
            console.error(error);
          })
      },

      resetForm() {
        this.routeMode = '';
        this.cityid = '';
        this.groupType = '';
        this.groupName = '';
        this.cityObjData = {
          value: "",
          text: ""
        };
        this.FilterCityObjData = {
          value: "",
          text: ""
        };
        this.FilterstateObjData = {
          value: "",
          text: ""
        };
        this.FilterhubzoneObjData = {
          value: "",
          text: ""
        };
        this.groupTypeObjData = {
          value: "",
          text: ""
        };
        this.addmodalShow= false;
        this.disabled= false;
        this.groupNumber='';
        this.statename='';
        this.filtercityid ='';
        this.filterstateid ='';
        this.filterhubzoneid ='';
        this.showdestination=false;
        this.cityLoading = '';
        this.GroupNumberError ='';
        this.destinationHubFound = false;
        this.resetDes();
        this.$validator.reset();
      },


    /* search button function call*/
      onSubmit: function() {
        this.$validator.validateAll('form')
            .then((result) => {
              if (!result) {
                this.clickedMB=false;
                return false;
              }else {
                  this.resetDes();
                  this.getSearchDestinations();
                }
              }).catch(() => {
              console.log('errors exist')
            });
        },

      closeStatusModal() {
        this.addmodalShow = false
      },
      /* search Button API call */
      getSearchDestinations() {
        this.connDestLoading    = true;
        this.DestinationList    = [];
        this.destData           = [];
        this.HubArr             = [];
        this.routemodeArr       = [];
        this.TotalAllocatedCount= 0;
        this.checkAllHub        = false;
        this.disabled           = false;
        this.clickedMB          = false;

        this.routeMode.forEach((item, i) => {
          this.routemodeArr.push(item.text)
        });

        this.input = ({
          cityid: this.cityid,
          routemode: this.routemodeArr,
          grouptype: parseInt(this.groupType)
        })

        if(this.filtercityid) this.input.filtercityid = this.filtercityid;
        if(this.filterstateid) this.input.filterstateid = this.filterstateid;
        if(this.filterhubzoneid) this.input.filterhubzoneid = this.filterhubzoneid;
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'searchGroup',
            'data':this.input,
            headers: {
              'Authorization': "authkey xB84JJ89Hd25"
            }
          })
          .then(result => {
            this.connDestLoading=false;
            if (result.data.ResultCode == 100) {
              this.disabledflag=true;
              let j=0, list=[], dlist=[],clen=0;
              this.groupNumber= result.data.groupno;
              this.disabled= this.groupNumber ? true :false;

              let hData = result.data.hubs;
               this.TotalAllocatedCount = hData.length;

                if(this.TotalAllocatedCount <= 0 && this.destinationHubFound == false){
                  this.$alertify.error(`No Destination Mapped For Selected RouteMode`);
                }
               if(this.destinationHubFound == true && this.TotalAllocatedCount == 0){
                 hData=[];
                 this.disabledflag=true;
               }
               else if(this.TotalAllocatedCount == 0){
                 this.disabledflag=false;
                 this.destinationHubFound =false;
                 this.checkAllHub = false;
                 this.getPanIndiaDestinations();
               }else {
                 this.destinationHubFound =true
              for (var i = 0; i < hData.length; i++) {
                if(j<4){
                  list.push({
                    hubId:hData[i].hubid,
                    hubName:hData[i].hubname
                  });
                }else{
                  dlist.push(list);
                  list=[]
                  list.push({
                    hubId:hData[i].hubid,
                    hubName:hData[i].hubname
                  });
                  j=0;
                }
                j++;

                  this.checked[hData[i].hubid] = true;
               }
               this.checkAllHub = true;
               dlist.push(list);
               this.DestinationList = dlist;
             }
           }else if (result.data.ResultCode == 102) {
              this.$alert(result.data.ReturnMessage, "", "error");
              this.disabledflag=false;
              this.DestinationList =[];
              this.destinationHubFound = false;
              if(result.data.groupno){
              this.groupNumber= result.data.groupno;
              this.disabled= this.groupNumber ? true :false;
              }
              this.getPanIndiaDestinations();
            }else {
               this.$alert(result.data.ReturnMessage, "", "error");
               this.disabledflag=false;
               this.DestinationList =[];
             }
          }, error => {
            this.connDestLoading=false;
            console.error(error)
          })
      },
      /* check uncheck the hubs function */
      checkHub() {
        if (this.checkAllHub) {

          for (var i = 0; i < this.destData.length; i++) {
              this.checked[this.destData[i].hubId]=true;
              this.modelArr.indexOf(this.destData[i].hubId) === -1 ? this.modelArr.push(parseInt(this.destData[i].hubId)):'';
          }
        }else{

          let arr=[];
          for (var i = 0; i < this.destData.length; i++) {
              this.checked[this.destData[i].hubId]=false;
              arr.push(this.destData[i].hubId);
          }

          this.modelArr = this.modelArr.filter(val => !arr.includes(val));
        }
      },

      updateCheckDest(event){
         this.checked[event.target.id] = event.target.checked;

         if(event.target.checked==false){
          this.modelArr = this.modelArr.filter(el => el != event.target.id)

         }else{
          this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
         }

         this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
       },

      /* save button function call */
      onSubmitHub: function(elem) {
       this.$validator.validateAll('form').then((result) => {
         if (!result) {
           return false;
         }else if (!this.groupNumber ) {
           this.GroupNumberError = 'Group Number Field Is Required'
           this.$refs.groupNumber.focus();
           this.$alertify.error('Group Number should not be empty'); return false;
         } else if (!this.allowOnlyNumbers()) {
           this.$refs.groupNumber.focus();
           return false;
         }else{
         this.addmodalShow = true
         }
       }).catch((Exception) => {
         console.error('exception is:::::::::',Exception)
       });
     },

     /* save button API function call */
      mapMultipleDestinations() {
       this.connDestLoading = true;
       this.clickedMB = true;

       let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));
       this.savroutemode = [...new Set(this.routeMode.map(a => a.text))];
       let num = this.groupNumber.replace(/[^0-9]/g, '');
       this.groupNumber = parseInt(num,10).toString();

       this.input = ({
         cityid   : this.cityid,
         routemode: this.savroutemode,
         grouptype: parseInt(this.groupType),
         groupname: this.groupName.toUpperCase(),
         groupno  : this.groupNumber,
         createdby: this.useremail,
         hublist  : nArr
       })

       axios({
           method: 'POST',
           'url': apiUrl.api_url_hubops + "createNewGroup",
           'data': this.input,
           headers: {
             'Authorization': "authkey xB84JJ89Hd25"
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
             this.$alert(result.data.ReturnMessage, "", "success");
             user_tracker.checkUserIP(this.userData[0], "CreateGroup", this.$route.path , this.input);
             this.resetForm();
           } else {
             this.$alert(result.data.ReturnMessage, "", "error");
           }
           this.connDestLoading = false;
         }, error => {
           this.connDestLoading = false;
           console.error(error)
         })
     },

     /* Pan India destinations API function call */
      getPanIndiaDestinations() {
      this.connDestLoading    = true;
      this.DestinationList = [];
      this.destData           = [];
      this.HubArr             = [];
      this.disabledflag       = false
      this.clickedMB          = true;
      this.checkAllHub = false;

      let inString = this.filtercityid ? '&cityid='+this.filtercityid :'';
      inString += this.filterstateid ? '&stateid='+this.filterstateid :'';
      inString+= this.filterhubzoneid ? '&hubzoneid='+this.filterhubzoneid :'';
      if(inString){
        inString = inString.substr(1);
      }
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getDestinationHubs'+ (inString ? '?' + inString : ''),
           headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode ==100) {
            let j=0, panlist=[], pandestlist=[], clen=0;
            let panhData = result.data.ResponseData;
            for (var i = 0; i < panhData.length; i++) {
              if(j<4){
                panlist.push({
                  hubId:panhData[i].hubid,
                  hubName:panhData[i].hubname,
                });
              }else{
                pandestlist.push(panlist);
                panlist=[]
                panlist.push({
                  hubId:panhData[i].hubid,
                  hubName:panhData[i].hubname,
                });
                j=0;
              }
              j++;

                (this.HubArr.indexOf(panhData[i].hubid) === -1) ? this.HubArr.push(panhData[i].hubid):'';
              if (this.checked[panhData[i].hubid] == true)
                clen++;

               this.destData.push({
                hubId:panhData[i].hubid,
                hubName:panhData[i].hubname,
              });

              const allH = this.allHubData.some(el => el.hubId === panhData[i].hubid);
              if (!allH) {
                this.allHubData.push({
                  hubId:panhData[i].hubid,
                  hubName:panhData[i].hubname
                });
              }
            }

            pandestlist.push(panlist);
            this.DestinationList = pandestlist;
            if (clen == this.destData.length && clen != 0)
              this.checkAllHub = true;
          }else{
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.connDestLoading=false;
        },
        error => {
          this.connDestLoading=false;
          console.error(error)
        })
    },

      takeAction() {
      this.mapMultipleDestinations();
     },

     resetDes(){
     this.HubArr= [];
     this.destData= [];
     this.allHubData= [];
     this.modelArr= [];
     this.checked= [];
     this.DestinationList= [];
     this.connDestLoading = false;
     this.checkAllHub= false;
     this.TotalAllocatedCount= 0;
     this.clickedMB=false;
     this.filtercityid ='';
     this.filterstateid ='';
     this.filterhubzoneid ='';
     this.disabledflag=false;
     this.pandIndiaLoading= false;
     this.showdestination=false;
   },

     resetMode(){
    this.destinationHubFound = false;
   },

    allowOnlyNumbers() {
      if (this.groupNumber && !(/^\d+$/).test(this.groupNumber)) {
        this.GroupNumberError = 'Please enter numberic value only';
        return false;
      }
      else {
        this.GroupNumberError = '';
        return true;
      }
  },

     getGroupTemplates() {
      this.groupLoading=true;
      if (this.citySearch == null || this.citySearch == undefined || this.citySearch == '') {
        return false;
      }
      if (this.citySearch != "") {

        this.totalRows = 0
        this.resultCount = 0;
        this.templateList = [];
        this.input = ({})
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'getCityWiseGroupsList?offset=' + this.pageNo + '&limit=' + this.limit + '&cityId=' + this.citySearch + '&isActive=' + this.citySearchStatus,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.templateList = result.data.ResponseData
              this.resultCount = result.data.ResponseData.length
              this.totalRows = result.data.TotalCount
              if (this.totalRows < this.limit) {
                this.pageCount = 1
              } else {
                this.pageCount = Math.ceil(this.totalRows / this.limit);
              }
            } else {
              this.templateList = 0
              this.resultCount = 0
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            this.groupLoading=false;
          }, error => {
            this.groupLoading=false;
            console.error(error)
          })
      } else {
        this.$alert("Please Select Any City", "", "error");
        return false;
      }
  },

     getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getGroupTemplates()
  },

     selectedCitySearch(searchCityData) {
      this.citySearchObjData = searchCityData;
      this.citySearch = searchCityData.value;
      this.citySearchName = searchCityData.text;
  },

     onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll('form-1').then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
  },

     changeGroupTemplateStatus() {
      this.isLoading = true;
      if (this.changestatus == 'De-Activate') {
        var newStatus = false;
      } else {
        var newStatus = true;
      }
      this.input = ({
        groupId: this.gptemplateid,
        cityId: this.gpCityId,
        isActive: newStatus,
        createdBy: this.useremail,
      })

      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'UpdateGroupsStatus',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then((result) => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert('Template Status Changed Successfully', "", "success");
            user_tracker.checkUserIP(this.userData[0], "CreateGroup", this.$route.path , this.input);
          }else{
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.groupStatusModal = false;
          this.getGroupTemplates();
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
  },

     getStatusRowData(data) {
      this.groupStatusModal = true;
      this.gptemplateid = data.groupid;
      this.gpstatus = data.isactive;
      this.gpCityId = data.cityid;
      if (data.isactive == true) {
        this.changestatus = 'De-Activate'
      } else {
        this.changestatus = 'Activate'
      }
  },

     closeStatusGroupModal() {
       this.groupStatusModal = false
  },
  resetDiv() {
    this.FilterCityObjData = {
      value: "",
      text: ""
    };
    this.filtercityid = '';
    this.FilterstateObjData = {
      value: "",
      text: ""
    };
    this.filterstateid = '';
    this.FilterhubzoneObjData = {
      value: "",
      text: ""
    };
    this.filterhubzoneid = '';
    this.selectFilter();
  }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/creategroup/creategroup.js